import { $platformCode } from "../../common"
// 根据ID查询商品信息
export function getGoodsByIds (data) {
  return this.fetch({
    method: 'post',
    url: 'mall-server/api/goods/v1/goodsByIds',
    platformCode: $platformCode,
    data
  })
}
